<template>
  <main>
      <div class="details">
    <h3>{{advice.title}}</h3>
    <p v-html="advice.content">&emsp;&emsp;{{advice.content}}</p>
    
      </div>
  </main>
</template>


<script>
import API from "../api/index";

export default {
     name: "advice",
     data() {
         return {
             advice: [],
         }
     },

     mounted() {
        var that = this;
        var movieId = that.$route.params.id;
        console.log(movieId);
        
        this.$http({
          method:'get',
          //params:movieId,
          params:{
            id: movieId
          },
          url:API.parkInfoGetById_url
      }).then(function(resp){
          console.log(resp.data);
          that.advice=resp.data.data;
      }).catch(resp => {
          console.log('请求失败：'+resp.status+','+resp.statusText);
      });
     },
    methods: {

        link(url) {
            this.$router.push(url)
    },

        }
}
</script>

<style scoped>

.details {
    margin: 50px;
    background-color: #ffffff;
}

.details h3 {
    font-size: 40px;
    margin: 20px;
    text-align: center;
}

.details p {
    font-size: 30px;
    margin: 20px;
    color: #999;
}

p {
    line-height: 50px;
    text-indent:60px;
}
</style>


// WEBPACK FOOTER //
// src/pages/advice.vue